__turbopack_context__.v({
  "enterFromLeft": "desktop-module__raNFia__enterFromLeft",
  "enterFromRight": "desktop-module__raNFia__enterFromRight",
  "enterIntoNav": "desktop-module__raNFia__enterIntoNav",
  "exitFromNav": "desktop-module__raNFia__exitFromNav",
  "exitToLeft": "desktop-module__raNFia__exitToLeft",
  "exitToRight": "desktop-module__raNFia__exitToRight",
  "navDropdownContent": "desktop-module__raNFia__navDropdownContent",
  "navViewport": "desktop-module__raNFia__navViewport",
});
